import { UserDTO } from './../../model/UserDTO';
import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { CommentDTO } from '../../model/CommentDTO';
import { DashboardService } from '../../services/dashboard.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { AlertMessageComponent } from '../alert-message/alert-message.component';
import { CommentResumeDTO } from '../../model/CommentResumeDTO';
import { Utils } from '../../utils/utils';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.css']
})
export class CommentComponent implements OnInit {

  @Input() loggedUser: UserDTO;
  @Input() comment: CommentResumeDTO;

  showResponseComment: boolean = false;
  responseComment: string = '';
  isLoading: boolean = false;



  constructor(
    private dashboardService: DashboardService,
    private modalService: NgbModal,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit(): void {
  }

  hasResponse() {
    if (this.comment.response) {
      return true;
    }
    return false;
  }

  getImageHappy() {
    if (this.comment) {

      if (this.comment.score > 8) {
        return './assets/custom/images/comments/happy.png';
      }
      if (this.comment.score > 6) {
        return './assets/custom/images/comments/shocked.png';
      }
      return './assets/custom/images/comments/sad.png';
    } else {
      return './assets/custom/images/comments/happy.png';
    }
  }

  getCommentInfo(): string {
    let info = this.comment.dateResponse + ', ';
    info += 'Key Driver: ' + this.comment.keyDriverTitle + ', ';
    info += 'Puntuación pregunta: ' + this.comment.score;
    info += (!this.comment.isAnonymous && this.comment.userFullName) ? ', ' : '';
    return info;
  }

  responseFeedback() {
    this.showResponseComment = !this.showResponseComment;
  }

  back() {
    this.showResponseComment = false;
  }

  saveComment() {
    if (this.responseComment == '' || this.isLoading) return;

    this.isLoading = true;
    this.dashboardService.saveComment(this.comment.deliverySurveyItemQuestionId, this.responseComment)
      .pipe(finalize(() => {
        this.isLoading = false;
        //this.changeDetectorRef.detectChanges();
      }))
      .subscribe(
        (res) => {

          this.comment.response = this.responseComment;
          this.comment.ownerFullName = this.loggedUser.lastName + ' ' + this.loggedUser.firstName;

          this.responseFeedback();
          //this.showSuccessMessage();
        },
        (err) => {
          console.log("ERR ", err);
        }
      )
  }

  showSuccessMessage() {
    const modalRef = this.modalService.open(AlertMessageComponent, { windowClass: 'animated fadeInDown' });
    modalRef.componentInstance.msg = 'GLOBAL.ACTION_SUCCESS';
    modalRef.componentInstance.successMessage = true;
    modalRef.result.then((result) => {
    }, (reason) => {
    });
  }

  getCircleColor(value: number): string {
    return Utils.getColorKeyDriver(false, value);
  }
}
